import React, { FC, useCallback, useMemo } from 'react';
import { ServiceProviderInterface } from '../interfaces';
import { useResponseHandlerService } from './response-handler.service';
import { useTranslation } from './translation.service';
import { useAuth0 } from '@auth0/auth0-react';

const apiUrl = process.env.REACT_APP_API_URL || '';
const serviceRootURL = `${apiUrl}/api/auth/`;
const headers = {
	'Content-Type': 'application/json',
	Authorization: '',
};

interface UserServiceInterface {
	acceptBasicFlow: (requestData: { email: string }) => Promise<any>;
}

interface UserProviderInterface extends ServiceProviderInterface {}

const { createContext, useContext } = React;

const UserContext = createContext<UserServiceInterface>({} as UserServiceInterface);

export const UserProvider: FC<UserProviderInterface> = (props) => {
	const { getIdTokenClaims } = useAuth0();
	const { addSuccess } = useResponseHandlerService();
	const { t } = useTranslation();
	const acceptBasicFlow = useCallback(
		async (requestData: { email: string }) => {
			const user = await getIdTokenClaims();
			headers.Authorization = user?.__raw || '';
			const res = await acceptBasicFlowApiCall(requestData);
			addSuccess(
				t(`Basic flow was successfully accepted for`) + ' ' + requestData.email
			);
			return res;
		},
		[addSuccess, getIdTokenClaims, t]
	);

	const value = useMemo(
		() => ({
			acceptBasicFlow,
		}),
		[]
	);

	return <UserContext.Provider value={value}>{props.children}</UserContext.Provider>;
};

export const useUserService = () => {
	return useContext<UserServiceInterface>(UserContext);
};

const acceptBasicFlowApiCall = async (requestData: { email: string }) => {
	try {
		const res = await window.fetch(`${serviceRootURL}acceptBasicFlow`, {
			method: 'POST',
			body: JSON.stringify(requestData),
			headers,
		});
		return res.json();
	} catch (e) {
		console.error(e);
		throw e;
	}
};
